import React, { useContext, ReactNode } from 'react'
import { Footer } from '../footer'
import { applicationConfiguration } from 'app/modules/shared'
import { useLocation } from 'react-router'

interface BaseLayoutProps {
  children: JSX.Element | JSX.Element[]
  appbar: ReactNode
  additionalContent?: ReactNode
}

/**
 * Base layout component shared by Users and Admins layouts
 */
export function BaseLayout({ children, appbar, additionalContent }: Readonly<BaseLayoutProps>): JSX.Element {
  const config = useContext(applicationConfiguration)
  const location = useLocation()
  const isSetup = ['/admin/setup', '/auth/first-signup/redirect'].includes(location.pathname) || config.firstRun

  if (isSetup) {
    return <>{children}</>
  }

  return (
    <>
      {appbar}

      <div className="main-container">
        {additionalContent}
        {children}
      </div>

      {config.showFooter ? <Footer /> : null}
    </>
  )
}
